// Navigation routes for quick reply actions in chat
export const ChatNavigationRoutes = {
  // Career exploration routes
  CAREERS_LIST: '/careers',
  USER_CAREERS: '/user-careers',
  CAREER_AWARENESS: '/career-awareness',
  COACHES_CORNER: '/coaches-corner',

  // Dashboard and main areas
  DASHBOARD: '/',
  PRIORITIZE: '/prioritize',

  // User onboarding
  ONBOARDING: '/on-boarding',
  ONBOARDING_START: '/on-boarding/start',

  // Partner areas
  PARTNER_DASHBOARD: '/partner-dashboard',
  PARTNER_CAREERS: '/partner-careers',
} as const

// Dynamic route generators
export const DynamicChatRoutes = {
  CAREER_INSIGHTS: (careerId: string) => `/careers/career-insights/${careerId}`,
  USER_CAREER_INSIGHTS: (careerId: string) =>
    `/user-careers/careers/career-insights/${careerId}`,
  DEEPER_DIVE: (careerId: string) => `/user-careers/deeper-dive/${careerId}`,
} as const

export type StaticChatNavigationRoute = keyof typeof ChatNavigationRoutes
export type DynamicChatNavigationRoute = keyof typeof DynamicChatRoutes

// Helper function to get route path
export const getChatNavigationRoute = (
  route: string,
  careerId?: string
): string => {
  // If route starts with '/', it's already a raw path - return as is
  if (route.startsWith('/')) {
    return route
  }

  // Check if it's a dynamic route
  if (route in DynamicChatRoutes && careerId) {
    const dynamicRoute = DynamicChatRoutes[route as DynamicChatNavigationRoute]
    return dynamicRoute(careerId)
  }

  // Fallback for dynamic routes without careerId
  switch (route) {
    case 'CAREER_INSIGHTS':
      return ChatNavigationRoutes.CAREERS_LIST
    case 'USER_CAREER_INSIGHTS':
      return ChatNavigationRoutes.USER_CAREERS
    case 'DEEPER_DIVE':
      return ChatNavigationRoutes.USER_CAREERS
    default:
      // Check if it's a static route
      if (route in ChatNavigationRoutes) {
        return ChatNavigationRoutes[route as StaticChatNavigationRoute]
      }
      return ChatNavigationRoutes.DASHBOARD
  }
}
